<p>cancel-dialog works!</p>
